export default __webpack_public_path__ + "static/media/chart-menu-icon.730d17d3.svg";